
<!-- <div class="menu-div">
  <h2 class="header">Add hashtags to your event</h2>
  <mat-divider></mat-divider>
  <span class="instruction">(Do not add # sign or any special characters with your hashtag)</span>
  <div class="hashtag-container">
    <div class="alert alert-info" *ngIf="showMessage !== ''">{{ showMessage }}</div>

    <form [formGroup]="formGroup" style="width: 80%;">
      <mat-slide-toggle labelPosition="before" formControlName="showHashtag" style="margin-bottom: 20px;">Show
        Hashtag</mat-slide-toggle>

      <div *ngIf="formGroup.controls['showHashtag'].value">
        <mat-form-field appearance="fill" class="example-full-width" style=" width: 85%; font-size: 15px;">
          <mat-label>Text above Hashtag(maximum 30 characters)</mat-label>
          <input matInput formControlName="textAboveHashtag" placeholder="Enter text" maxlength="30">
        </mat-form-field>
      </div>

      <div *ngIf="formGroup.controls['showHashtag'].value">
        <mat-form-field appearance="fill" class="example-full-width" style=" width: 85%; font-size: 15px;">
          <mat-label>Hashtag</mat-label>
          <input matInput type="text" formControlName="hashtagInput" placeholder="#">
        </mat-form-field>
        <div
          *ngIf="formGroup.controls['hashtagInput'].invalid && (formGroup.controls['hashtagInput'].dirty || formGroup.controls['hashtagInput'].touched)">
          <small *ngIf="formGroup.controls['hashtagInput'].errors?.['pattern']">Invalid character(s) in hashtag.</small>
        </div>
      </div>
      <div class="overlay" *ngIf="isSavingData">
        <div class="lds-roller">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div style="text-align: center;margin-top:5%"  *ngIf="formGroup.controls['showHashtag'].value">
        <h2>Preview</h2>
        <div class="caption nunito-slides">
          <span style="font-size: 14px;text-align: center;">{{ formGroup.value.textAboveHashtag }}</span>
          <p>#{{ formGroup.value.hashtagInput }}</p>
        </div>
      </div>
      <br>
      <button mat-raised-button class="btn btn-primary save-button" type="button"
        [disabled]="!formGroup.dirty || formGroup.invalid || isbtnDisabled" (click)="saveHashtags()">Save</button>
    </form>
  </div>
</div> -->
<div class="menu-div1">
  <h2 class="header">Add Hashtags to Your Event</h2>
  <mat-divider></mat-divider>
  <span class="instruction">(Do not add # sign or any special characters with your hashtag)</span>

  <div class="hashtag-container">
    <div class="alert alert-info" *ngIf="showMessage !== ''">{{ showMessage }}</div>

    <form [formGroup]="formGroup" class="hashtag-form">
      <div class="toggle-container">
      <mat-slide-toggle formControlName="showHashtag" class="slide-toggle">
        Show Hashtag
      </mat-slide-toggle>
      </div>

      <div *ngIf="formGroup.controls['showHashtag'].value">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Text Above Hashtag (maximum 30 characters)</mat-label>
          <input matInput formControlName="textAboveHashtag" placeholder="Enter text" maxlength="30">
        </mat-form-field>
      </div>
      <div class="overlay" *ngIf="isSavingData">
         <span class="loader"></span>
      </div>

      <div *ngIf="formGroup.controls['showHashtag'].value">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Hashtag</mat-label>
          <input matInput type="text" formControlName="hashtagInput" placeholder="#">
        </mat-form-field>
        <div
          *ngIf="formGroup.controls['hashtagInput'].invalid && (formGroup.controls['hashtagInput'].dirty || formGroup.controls['hashtagInput'].touched)">
          <small *ngIf="formGroup.controls['hashtagInput'].errors?.['pattern']">Invalid character(s) in hashtag.</small>
        </div>
      </div>

      <div style="text-align: center;margin-top:5%"  *ngIf="formGroup.controls['showHashtag'].value">
        <h2>Preview</h2>
        <div class="caption nunito-slides">
          <span style="font-size: 14px;text-align: center;">{{ formGroup.value.textAboveHashtag }}</span>
          <p style="white-space: nowrap;overflow: hidden;height: 30px;; text-overflow: ellipsis;max-width: 250px;">#{{ formGroup.value.hashtagInput }}</p>
        </div>
      </div>

      <button mat-raised-button class="save-button" type="button" *ngIf="formGroup.controls['showHashtag'].value"
        [disabled]="!formGroup.dirty || formGroup.invalid || isbtnDisabled" (click)="saveHashtags()">Save</button>
    </form>
  </div>
</div>